import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";

class FormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    toggleCompany(e) {
        this.props.handleChange(e);
        this.state.showCompany = ! this.state.showCompany;
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            contactType,
            setFieldValue,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="contact_type" value={values.contact_type} onChange={handleChange}/>

                <FormCheck
                    name="is_company"
                    label={i18n.get('contacts.' + contactType) + ' ' + i18n.get('contacts.is_a_company')}
                    onChange={this.toggleCompany.bind(this)}
                    onBlur={handleBlur}
                    value={values.is_company}
                />

                <Grid container spacing={24}>
                    {values.is_company && (
                        <Grid item xs={12}>
                            <FormField
                                type="text"
                                name="company_name"
                                label={i18n.get('contacts.company_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.company_name}
                                error={errors.company_name}
                                touched={touched.company_name}
                            />
                        </Grid>
                    )}

                    {contactType == 'craft' && (
                        <Grid item xs={12}>
                            <FormField
                                type="text"
                                name="department"
                                helperText={i18n.get('contacts.department_helper_text')}
                                label={i18n.get('contacts.department')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.department}
                                error={errors.department}
                                touched={touched.department}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            autoComplete={false}
                            name="search_number"
                            label={i18n.get('contacts.search_number')}
                            label_exclaim={i18n.get('contacts.search_number_explain')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.search_number}
                            error={errors.search_number}
                            touched={touched.search_number}
                        />
                    </Grid>
                    <Grid item xs={12} spacing={0}>
                        {/*Divider*/}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormSelect
                            type="text"
                            name="salutation"
                            label={i18n.get('contacts.salutation')}
                            onChange={option => setFieldValue('salutation', option.value)}
                            onBlur={handleBlur}
                            value={values.salutation}
                            error={errors.salutation}
                            touched={touched.salutation}
                            options={[
                                {label: 'Herr', value: 'Herr'},
                                {label: 'Frau', value: 'Frau'}
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="first_name"
                            label={i18n.get('contacts.first_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.first_name}
                            error={errors.first_name}
                            touched={touched.first_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="last_name"
                            label={i18n.get('contacts.last_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.last_name}
                            error={errors.last_name}
                            touched={touched.last_name}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="street"
                            label={i18n.get('contacts.street')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.street}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="housenumber"
                            label={i18n.get('contacts.housenumber')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.housenumber}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="zip"
                            label={i18n.get('contacts.zip')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.zip}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="city"
                            label={i18n.get('contacts.city')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.city}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="telephone"
                            label={i18n.get('contacts.telephone')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.telephone}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="email"
                            name="email"
                            label={i18n.get('contacts.email')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="website"
                            label={i18n.get('contacts.website')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.website}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/contacts/${values.id}`}
                                confirmMessage={i18n.get('contacts.confirm_message')}
                                successMessage={i18n.get('contacts.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('contacts.update') : i18n.get('contacts.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default FormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contacts/FormFields.js